import { ChevronRightOutlined, MoreVert } from "@material-ui/icons";
import React, { useContext, useState } from "react";
import { Dropdown } from "react-bootstrap";
import EditInternMeetingTopipc from "../../components/modals/EditInternMeetingTopic";
import DeleteModal from "../../components/modals/DeleteModal";
import RescheduleTeamMeetngModal from "../../components/modals/RescheduleTeamMeetingModal";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import HistoryIcon from "@mui/icons-material/History";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicToast from "../../components/toasts/BasicToast";
import { connect } from "react-redux";
import dateFormat from "dateformat";
const TeamMeetingItem = ({ item, index, value,dispatch }) => {
  const { user } = useContext(AuthContext);

  const [toast, setToast] = useState(false);
  const [toastData, setToastData] = useState({ title: null, message: null });

  const [edittopic, setedittopic] = useState(false);
  const [deletemodal, setdeletemodal] = useState(false);
  const [reschedule, setreschedule] = useState(false);

  const DeleteTeamMeeting = async () => {
    dispatch({ type: 'LOADING' }); // Start loading state
  
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("id", item.id);
  
    try {
      const res = await axios.post(
        ENDPOINT + "delete-team-meeting.php",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );
  
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' }); // End loading state only on success
          dispatch({ type: 'FUNCTION_RELOAD', payload: 'get-intern-meetings' });
          setdeletemodal(false);
        } else {
          dispatch({ 
            type: 'ERROR', 
            payload: res.data.message || 'Failed to delete meeting'
          });
        }
        setToast(true);
        setToastData({ 
          title: res.data.title || 'Success', 
          message: res.data.message || 'Meeting deleted successfully' 
        });
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: 'Invalid response format'
        });
        setToast(true);
        setToastData({ 
          title: 'Error', 
          message: 'Invalid response format' 
        });
      }
    } catch (error) {
      setToast(true);
      setToastData({ 
        title: 'Error', 
        message: error.message || 'An error occurred while deleting the meeting' 
      });
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while deleting team meeting'
      });
    }
  };

  return (
    <>
      <BasicToast
        visibility={toast}
        item={toastData}
        ToastHandleClose={() => setToast(false)}
      />
      <EditInternMeetingTopipc
       
        visibility={edittopic}
        handleClose={() => setedittopic(false)}
        item={item}
      />
      <RescheduleTeamMeetngModal
       
        visibility={reschedule}
        item={item}
        handleClose={() => setreschedule(false)}
      />
      <DeleteModal
        HandleClose={() => setdeletemodal(false)}
        show={deletemodal}
        HandleDelete={DeleteTeamMeeting}
      />
      <div className="col-lg-6 col-12 col-sm-10 col-md-6 col-xl-6 p-2">
        <div className=" shadow border bg-white  rounded p-3 mb-2">
          <div className=" w-100 flex">
            <div className="w-100">
              <h5 className="mb-0 w-100">{item.title}</h5>
              <p className="p-0 m-0">{item.starts}</p>
            </div>

            <Dropdown className="options-dropdown">
              <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0">
                <MoreVert className="text-dark" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setreschedule(true)}>
                  {" "}
                  <HistoryIcon className="me-2" /> Rechedule
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setedittopic(true)}>
                  {" "}
                  <EditIcon className="me-2" /> Edit Topic
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setdeletemodal(true)}>
                  {" "}
                  <DeleteIcon className="me-2" /> Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <hr />
          <div className="flex space-between">
            <p
              className={
                index / 2
                  ? "mb-0 w-auto text-success"
                  : index / 3
                  ? "mb-0  w-auto  text-danger"
                  : index / 5
                  ? "mb-0  w-auto  text-primary"
                  : "mb-0  w-auto  text-warning"
              }
            >
              <b>{item.day}</b>
            </p>

            <p className="mb-0 text-secondary"></p>
          </div>

          <div className="container-fluid p-0 text-secondary">
            <p className="text-truncate m-0">{item.description}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            
          <p className="mb-0 text-secondary m-0">
  {
    item.time && !isNaN(new Date(item.time).getTime()) 
      ? dateFormat(item.time, "dS mmm yy hh:mm:tt")
      : item.date
  }
</p>

            
             {item.status === "incomplete" ? (
              <>
                <a
                  href={item.link}
                  className="w-auto btn btn-primary btn-sm rounded-pill"
                >
                  Join Meeting <ChevronRightOutlined />{" "}
                </a>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
const reload = (prop)=>({
  value:prop.modalHandler
})

export default connect(reload) (TeamMeetingItem);
